import React, { useMemo } from 'react';
import { Stack, Typography } from '@mui/material';

import { useDragOrder } from '../hooks/useDragOrder';
import { RoleListItem } from './RoleListItem';

export const RoleGroup = ({ structure, roles, searchTerm, onReorder, onEdit, onDelete }) => {
  const structureId = structure.level_structure_id;
  const structureRoles = useMemo(
    () => roles.filter(({ level_structure_id }) => level_structure_id === structureId),
    [roles, structureId]
  );
  const { order, draggedId, dragHandlers } = useDragOrder(structureRoles, 'role_id', (roleIds) =>
    onReorder(structureId, roleIds)
  );

  const filteredRoles = order.filter(
    ({ name, description }) =>
      name.toLowerCase().includes(searchTerm) || description.toLowerCase().includes(searchTerm)
  );
  const canDrag = !searchTerm && order.length > 1;

  return (
    <Stack gap={1}>
      <Typography variant="body2" fontWeight={700} pl={2}>
        {structure.name}
      </Typography>
      {filteredRoles.map((role) => (
        <RoleListItem
          key={role.role_id}
          canDrag={canDrag}
          isDragged={draggedId === role.role_id}
          dragHandlers={dragHandlers(role.role_id)}
          markForEdit={() => onEdit(role)}
          markForDelete={() => onDelete(role)}
          {...role}
        />
      ))}
    </Stack>
  );
};
